<template>
  <div class="wrapper add-knowledge">
    <b-modal
      id="modal"
      v-model="isOpen"
      header-bg-variant="light"
      footer-bg-variant="light"
      :title="$t('pages.user-cv.employment.modal.title', 'Edit employment status')"
      :ok-title="$t('generic.save', 'Save')"
      :cancel-title="$t('generic.cancel', 'Cancel')"
      @hidden="$emit('closeModal'); reset()"
      @ok.prevent="validate"
      @show="reset()"
    >
      <!-- Levels and exp -->
      <div class="d-flex justify-content-between">
        <strong class="smallTitle">{{ $t('pages.user-cv.employment.modal.experience.title', 'Your levels and experience') }}</strong>
      </div>
      <hr class="horizontalr">
      <label for="speakSelect">{{ $t('pages.user-cv.employment.modal.experience.preference', 'What levels of work are you interested in?') }}</label>
      <multiselect
        v-model="$v.levelsSelected.$model"
        :options="levelsOptions"
        :class="[$v.levelsSelected.$error ? 'error' : '']"
        :multiple="true"
        track-by="value"
        label="text"
        :placeholder="$t('inputs.option.placeholder', 'Select option')"
        :deselect-label="$t('pages.user-cv.multiselect.press-enter-remove', 'Press enter to remove')"
        :select-label="$t('pages.user-cv.multiselect.press-enter-select', 'Press enter to select')"
        :selected-label="$t('pages.user-cv.multiselect.press-enter-selected', 'Selected')"
      />
      <label for="speakSelect">{{ $t('pages.user-cv.employment.modal.experience.current', 'How much experience do you have?') }}</label>
      <b-form-select
        id="langSelect"
        v-model="$v.experienceSelected.$model"
        :options="experienceOptions"
        :state="$v.experienceSelected.$dirty ? !$v.experienceSelected.$error : null"
      />

      <!-- Industries and categories -->
      <div class="d-flex justify-content-between">
        <strong class="smallTitle">{{ $t('pages.user-cv.employment.modal.industries.title', 'Your industries and categories') }}</strong>
      </div>
      <hr class="horizontalr">
      <label for="speakSelect">{{ $t('pages.user-cv.employment.modal.industries.categories', 'Your categories') }}</label>
      <multiselect
        v-model="$v.categoriesSelected.$model"
        :options="categoriesOptions"
        :multiple="true"
        track-by="value"
        label="text"
        :class="[$v.categoriesSelected.$error ? 'error' : '']"
        :placeholder="$t('inputs.option.placeholder', 'Select option')"
        :deselect-label="$t('pages.user-cv.multiselect.press-enter-remove', 'Press enter to remove')"
        :select-label="$t('pages.user-cv.multiselect.press-enter-select', 'Press enter to select')"
        :selected-label="$t('pages.user-cv.multiselect.press-enter-selected', 'Selected')"
      />

      <label for="speakSelect">{{ $t('pages.user-cv.employment.modal.industries.industries', 'Your industries') }}</label>
      <multiselect
        v-model="$v.industriesSelected.$model"
        :options="industriesOptions"
        :multiple="true"
        track-by="value"
        label="text"
        :class="[$v.industriesSelected.$error ? 'error' : '']"
        :placeholder="$t('inputs.option.placeholder', 'Select option')"
        :deselect-label="$t('pages.user-cv.multiselect.press-enter-remove', 'Press enter to remove')"
        :select-label="$t('pages.user-cv.multiselect.press-enter-select', 'Press enter to select')"
        :selected-label="$t('pages.user-cv.multiselect.press-enter-selected', 'Selected')"
      />

      <!-- Contracts -->
      <div class="d-flex justify-content-between">
        <strong class="smallTitle">{{ $t('pages.user-cv.employment.modal.contracts.title', 'Your contracts') }}</strong>
      </div>
      <hr class="horizontalr">
      <label for="speakSelect">{{ $t('pages.user-cv.employment.modal.contracts.contracts', 'Contracts') }}</label>
      <multiselect
        v-model="$v.contractsSelected.$model"
        :options="contractsOptions"
        :multiple="true"
        track-by="value"
        label="text"
        :class="[$v.contractsSelected.$error ? 'error' : '']"
        :placeholder="$t('inputs.option.placeholder', 'Select option')"
        :deselect-label="$t('pages.user-cv.multiselect.press-enter-remove', 'Press enter to remove')"
        :select-label="$t('pages.user-cv.multiselect.press-enter-select', 'Press enter to select')"
        :selected-label="$t('pages.user-cv.multiselect.press-enter-selected', 'Selected')"
      />
    </b-modal>
  </div>
</template>

<script>
    import {categories, contractTypes, experience, industryTypes, levels,} from "@/assets/data";
    import {required} from "vuelidate/lib/validators";

    export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    levels: {
      type: String,
      default: ""
    },
    experience: {
      type: String,
      default: ""
    },
    categories: {
      type: String,
      default: ""
    },
    industries: {
      type: String,
      default: ""
    },
    contracts: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      // Levels and exp
      levelsSelected: null,
      experienceSelected: null,

      // Categories and industries
      categoriesSelected: null,
      industriesSelected: null,

      // Contracts
      contractsSelected: null,
    }
  },
  computed: {
    categoriesOptions() {
      let categoriesOptions = categories();
      categoriesOptions.shift();
      return categoriesOptions;
    },
    levelsOptions() {
      return levels();
    },
    experienceOptions() {
      let experienceOptions = experience();
      experienceOptions[1] = {
        value: "No tengo",
        text: this.$t('data.experience.No tengo', 'No tengo')
      };
      return experienceOptions;
    },
    industriesOptions() {
      let industriesOptions = industryTypes();
      industriesOptions.shift();
      return industriesOptions;
    },
    contractsOptions() {
      let contractsOptions = contractTypes();
      contractsOptions.shift();
      return contractsOptions;
    }
  },
  validations: {
    levelsSelected:  { required },
    experienceSelected: { required },
    categoriesSelected: { required },
    industriesSelected: { required },
    contractsSelected: { required }
  },
  methods: {
    handleOk() {
    this.axios.put('/cv/update/employment', {
        levels: JSON.stringify(this.levelsSelected.map(item => item.value)),
        experience: this.experienceSelected,
        categories: JSON.stringify(this.categoriesSelected.map(item => item.value)),
        industries: JSON.stringify(this.industriesSelected.map(item => item.value)),
        contracts: JSON.stringify(this.contractsSelected.map(item => item.value)),
      })
      .then(response => {
        this.$emit('updateCv', response.data);
        this.$emit('closeModal');
        this.$toastNotification('success', '', this.$t('pages.user-cv.profile-update.success', 'Profile updated successfully!'));
      })
      .catch(() => {
        this.$toastSomethingWentWrong();
      });
    },
    reset() {
      if (this.levels) {
        this.levelsSelected = JSON.parse(this.levels).map(item => ({
          value: item,
          text: this.$t(`data.levels.${item}`, item)
        }));
      }
      if (this.experience) {
        this.experienceSelected = this.experience;
      }
      if (this.categories) {
        this.categoriesSelected = JSON.parse(this.categories).map(item => ({
          value: item,
          text: this.$t(`data.categories.${item}`, item)
        }));
      }
      if (this.industries) {
        this.industriesSelected = JSON.parse(this.industries).map(item => ({
          value: item,
          text: this.$t(`data.industryTypes.${item}`, item)
        }));
      }
      if (this.contracts) {
        this.contractsSelected = JSON.parse(this.contracts).map(item => ({
          value: item,
          text: this.$t(`data.contractTypes.${item}`, item)
        }));
      }
    },
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$toastNotification('danger', '', this.$t('pages.user-cv.profile-update.failure', 'All fields must be filled!'));
        return false;
      } else {
        this.handleOk();
        return true;
      }
    }
  }
}
</script>

<style lang="scss">
  .add-knowledge {
    font-size: 0.9rem;
  }

  .smallTitle {
    font-size: 1rem;
    margin-top: 1rem;
  }

  .horizontalr {
    margin-top: 0;
    margin-bottom: 0.2rem;
  }

  .error {
    border: 1px solid red;
    border-radius: 5px;
  }
</style>
